<template lang="">
    <div>
       
        <b-card>
            <b-row v-for="item in fld" :key="item.key">
                <b-col v-if="item.type=='text'" md="5">
                    <b-form-group :label="item.label" label-cols="4">
                        <b-form-input  v-model="item.value"  label-cols="4"></b-form-input>
                    </b-form-group>
                </b-col>
         
                <b-col  v-if="item.type=='date'" md="5">
                    <b-form-group :label="item.label" label-cols="4">
                        <b-form-datepicker v-model="item.value" locale="lao"></b-form-datepicker>
                    </b-form-group>
                </b-col>
          
                <b-col  v-if="item.type=='select1'" md="5">
                    <b-form-group :label="item.label" label-cols="4">
                        <b-form-select v-model="item.value" :options="select1" required  >
                        </b-form-select>
                    </b-form-group>
                 
                </b-col>
                <b-col  v-if="item.type=='select2'" md="5">
                    <b-form-group :label="item.label" label-cols="4">
                        <b-form-select v-model="item.value" :options="select2" required  >
                        </b-form-select>
                    </b-form-group>
                 
                </b-col>
                <b-col  v-if="item.type=='select3'" md="5">
                    <b-form-group :label="item.label" label-cols="4">
                        <b-form-select v-model="item.value" :options="select3" required  >
                        </b-form-select>
                    </b-form-group>
                 
                </b-col>
                <b-col  v-if="item.type=='select4'" md="5">
                    <b-form-group :label="item.label" label-cols="4">
                        <b-form-select v-model="item.value" :options="select4" required  >
                        </b-form-select>
                    </b-form-group>
                 
                </b-col>
                <b-col  v-if="item.type=='select5'" md="5">
                    <b-form-group :label="item.label" label-cols="4">
                        <b-form-select v-model="item.value" :options="select5" required  >
                        </b-form-select>
                    </b-form-group>
                 
                </b-col>
                
            </b-row>
            <b-row>
                <b-col md=5>
                    <b-button block variant="primary" @click="onPreview" >ເບິ່ງລາຍງານ</b-button>

                </b-col>
            </b-row>
             
           
        </b-card>
    </div>
</template>
<script>
import axios from "axios";
export default {
  created () {
    axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getReportParams?menuid="+ this.$route.query.id
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.fld = JSON.parse( response.data.fields);
                this.sp_name=response.data.sp_name
                this.rpt_name=response.data.rpt_name

                   //  console.log( this.fld)

                   this.fld.forEach(element => {
                        if (element.type=="select1") {
                            
                                axios.get(
                                        this.$store.getters.getBaseUrl + element.url
                                    
                                    )
                                    .then((response) => {
                                        // JSON responses are automatically parsed.
                                        this.select1 = response.data;
                                        //    console.log(  JSON.parse(response.data))
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                });
                        }else if(element.type=="select2"){
                            axios.get(
                                        this.$store.getters.getBaseUrl + element.url
                                    
                                    )
                                    .then((response) => {
                                        // JSON responses are automatically parsed.
                                        this.select2 = response.data;
                                        //    console.log(  JSON.parse(response.data))
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                });

                        }else if(element.type=="select3"){
                            axios.get(
                                        this.$store.getters.getBaseUrl + element.url
                                    
                                    )
                                    .then((response) => {
                                        // JSON responses are automatically parsed.
                                        this.select3 = response.data;
                                        //    console.log(  JSON.parse(response.data))
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                });

                        }else if(element.type=="select4"){
                            axios.get(
                                        this.$store.getters.getBaseUrl + element.url
                                    
                                    )
                                    .then((response) => {
                                        // JSON responses are automatically parsed.
                                        this.select4 = response.data;
                                        //    console.log(  JSON.parse(response.data))
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                });

                        }else if(element.type=="select5"){
                            axios.get(
                                        this.$store.getters.getBaseUrl + element.url
                                    
                                    )
                                    .then((response) => {
                                        // JSON responses are automatically parsed.
                                        this.select5 = response.data;
                                        //    console.log(  JSON.parse(response.data))
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                });

                        }
                    
                   });
               

            })
            .catch((e) => {
                console.log(e);
            });
  },
  data () {
    return {
        fld:[],
        sp_name:"",
        rpt_name:"",
        items:[],
        select1:[],
        select2:[],
        select3:[],
        select4:[],
        select5:[],
        pm:"",
       
        script:"",
        rpt_param:{
                branch_id:"",
                from_date:"",
                to_date:"",
                reportname: this.$route.params.rptname,
                account_code:"",
                script:`call sp_account_hist('111','2017-01-01','2017-12-31','66100000.00')`
        }
    }
  },
  methods: {
    goback() {
            this.$router.go(-1)
    },
    getSelect(){
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/branch/branch_name/branch_id"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.items = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });
    },
    onPreview(){
           let tpm=""
            this.fld.forEach(item => {
                tpm =tpm+ "'"+item.value+"',"
                if(item.key=="branch_id") {
                    this.rpt_param.branch_id=item.value
                }else if(item.key=="from_date"){
                    this.rpt_param.from_date=item.value
                }else if(item.key=="to_date"){
                    this.rpt_param.to_date=item.value
                }
            })

            let script = tpm.substring(0,tpm.length-1);
            this.rpt_param.script="call "+ this.sp_name + "("+script+")"
        //    this.rpt_param.branch_id=this.it
         //   this.fld.script=`call sp_account_hist('`+this.fld.branch_id+`','`+this.fld.from_date+`','`+this.fld.to_date+`','`+this.fld.account_code+`')`
            let data = JSON.stringify(this.rpt_param);
            this.$router.push('/view_dna/'+this.rpt_name+'?data='+data)
        }
  },
    
}
</script>
<style lang="">
    
</style>